export interface CmsValidationEntry {
  label: string;
  message: string;
}

/**
 * Builds a page-level validation summary from labeled field errors.
 */
export const buildCmsValidationSummary = (
  entries: readonly CmsValidationEntry[],
): string | null => {
  if (entries.length === 0) return null;

  const details = entries
    .map(({ label, message }) => `${label} — ${message}`)
    .join("; ");

  return `Revisá los siguientes campos: ${details}`;
};

/**
 * Builds a validation summary from a fieldErrors record and a label map.
 */
export const buildCmsValidationSummaryFromRecord = (
  fieldErrors: Partial<Record<string, string>>,
  labels: Record<string, string>,
): string | null => {
  const entries = Object.entries(fieldErrors)
    .filter((entry): entry is [string, string] => Boolean(entry[1]))
    .map(([field, message]) => ({
      label: labels[field] ?? field,
      message,
    }));

  return buildCmsValidationSummary(entries);
};
